import { funAcortarText } from "../../../../../global/utils/text";
import CorazonIcon from "../../../../assets/images/generico/CorazonIcon";
import { ValidaTurnoCard } from "./localStyle";

const CardBlueHeart = (
    {
        turnoTitle,
        medico, 
        pasoActual, 
        pasoTotal
    }) => {
   
    return (
        <ValidaTurnoCard>
          <CorazonIcon
            color={"var(--color-white)"}
            clase="resumencard-corazonIcon"
          />
          <div className="number">
            <span>TURNO</span>
            <span> {pasoActual} de {pasoTotal}: </span>
          </div>
          <div className="text">
                <span>{funAcortarText(20,turnoTitle)}</span>
                <span>{funAcortarText(20,medico)}</span>
          </div>
        </ValidaTurnoCard>
    )
}

export default CardBlueHeart; 